/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Subscriber_LabelInputs */

const tr_mesafeli_s1_subscriber_label = /** @type {(inputs: Mesafeli_S1_Subscriber_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone (Müşteri):`)
};

const en_mesafeli_s1_subscriber_label = /** @type {(inputs: Mesafeli_S1_Subscriber_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriber (Customer):`)
};

const de_mesafeli_s1_subscriber_label = /** @type {(inputs: Mesafeli_S1_Subscriber_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnent (Kunde):`)
};

const ru_mesafeli_s1_subscriber_label = /** @type {(inputs: Mesafeli_S1_Subscriber_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абонент (Клиент):`)
};

/**
* | output |
* | --- |
* | "Subscriber (Customer):" |
*
* @param {Mesafeli_S1_Subscriber_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_subscriber_label = /** @type {((inputs?: Mesafeli_S1_Subscriber_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Subscriber_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_subscriber_label(inputs)
	if (locale === "de") return de_mesafeli_s1_subscriber_label(inputs)
	if (locale === "ru") return ru_mesafeli_s1_subscriber_label(inputs)
	return tr_mesafeli_s1_subscriber_label(inputs)
});